var map = {
	"./modules/cart/en-AU.json": 92573,
	"./modules/cart/en-CA.json": 3558,
	"./modules/cart/en-GB.json": 58543,
	"./modules/cart/en-SG.json": 55221,
	"./modules/cart/en-US.json": 44913,
	"./modules/checkout/en-AU.json": 97336,
	"./modules/checkout/en-CA.json": 37115,
	"./modules/checkout/en-GB.json": 55225,
	"./modules/checkout/en-SG.json": 31554,
	"./modules/checkout/en-US.json": 40525,
	"./modules/order/en-AU.json": 50151,
	"./modules/order/en-CA.json": 26932,
	"./modules/order/en-GB.json": 46510,
	"./modules/order/en-SG.json": 30140,
	"./modules/order/en-US.json": 74581,
	"./modules/product/en-AU.json": 62260,
	"./modules/product/en-CA.json": 55607,
	"./modules/product/en-GB.json": 65497,
	"./modules/product/en-SG.json": 98141,
	"./modules/product/en-US.json": 96472,
	"./modules/search/en-AU.json": 40225,
	"./modules/search/en-CA.json": 6802,
	"./modules/search/en-GB.json": 92730,
	"./modules/search/en-SG.json": 40512,
	"./modules/search/en-US.json": 92575,
	"./modules/user/en-AU.json": 67681,
	"./modules/user/en-CA.json": 89661,
	"./modules/user/en-GB.json": 32137,
	"./modules/user/en-SG.json": 29474,
	"./modules/user/en-US.json": 46430,
	"./shared/en-AU.json": 44897,
	"./shared/en-CA.json": 21339,
	"./shared/en-GB.json": 8745,
	"./shared/en-SG.json": 15999,
	"./shared/en-US.json": 7004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36096;